// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "130" ? "__federation_expose_CrmManage" : chunkId) + "." + {"130": "64864ed0","267": "ec5ff1ec","396": "8da410d8","75": "b7b2d77e",}[chunkId] + ".js"
}